import { decodeBase64Url } from '@/utils/string-helpers/decode-base64'

import { ActiveExperiment, activeExperimentSchema } from './schema'

export function parseActiveExperiments(raw: unknown): ActiveExperiment[] {
    const parsedActiveExperiments: ActiveExperiment[] = []
    if (!raw || typeof raw !== 'string') return parsedActiveExperiments

    let decoded: string
    try {
        decoded = decodeBase64Url(raw)
    } catch {
        return parsedActiveExperiments
    }

    let candidate: unknown
    try {
        candidate = JSON.parse(decoded)
    } catch {
        try {
            candidate = JSON.parse(decoded)
        } catch {
            return parsedActiveExperiments
        }
    }

    if (!Array.isArray(candidate)) return parsedActiveExperiments

    for (const item of candidate) {
        const result = activeExperimentSchema.safeParse(item)
        if (result.success) {
            parsedActiveExperiments.push(result.data)
        }
    }

    return parsedActiveExperiments
}
